import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  constructor(private router:Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

  navigateToReportErrors() {
    this.router.navigate(['admin/reportErrors.do']);
    }

  navigateToReportVINIssue() {
    this.router.navigate(['admin/reportVinIssue.do']);
  }

  navigateToReportReadVin() {
    this.router.navigate(['admin/reportReadVin.do']);
  }

  navigateToReportVci() {
    this.router.navigate(['admin/reportVciIssue.do']);
  }
  navigateToReportLostCommunication() {
    this.router.navigate(['admin/reportLostCommunication.do']);
  }
  navigateToVinMismatchErrors() {
    this.router.navigate(['admin/reportVinMismatch.do']);
  }
  navigateToUnsupportedBrowser() {
    this.router.navigate(['admin/reportBrowser.do']);
  }
  openPdfDocument() {
    const path = 'assets/SBDO pop up error messages January 2026.pdf';
  window.open(path, '', 'width=800,innerHeight=800,resizable=yes,scrollbars=yes');
  }
}
